import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, forkJoin, Observable, of, Subject, throwError } from 'rxjs';
import { catchError, concatMap, filter, map, switchMap, tap } from 'rxjs/operators';
import { environment } from '@environments/environment';
import { CrudOperations } from '@app/shared/helpers/interfaces/crud-operations';
import { TipoPaginadorEnum } from '@appNeo/neoShared/helpers/enums/TipoPaginador.enum';
import { Paginator } from '@app/shared/models/paginator/paginator';
import { ProyectoTipoInterface } from '@app/core/interfaces/proyecto-tipo-interface';
import { IRequestPatchProyecto, IRequestPostProyecto, ProyectoInterface, RequestPatchJefeProyecto } from '@app/core/interfaces/proyecto-interface';
import { ProyectoTipoServicioInterface } from '@app/core/interfaces/proyecto-servicio-interface';
import { RespApi } from '@app/shared/helpers/interfaces/resp-api';
import { AuxiliarService } from '@app/shared/services/auxiliar/auxiliar.service';
import { IConceptoDefecto, RequestPostConceptosDesfecto } from '@app/core/interfaces/IConceptos';
import { IHitosFacturacionDefecto, RequestPostHitosFacturacionDefecto } from '@app/core/interfaces/IHitosFacturacion';
import { EmpleadosService } from '../empleados/empleados.service';
import { ProcedenciasService } from '../procedencias/procedencias.service';
import { TiposMedioContactoService } from '../tipos/tiposMedioContacto/tipos-medio-contacto.service';
import { CuentasService } from '../cuentas/cuentas.service';
import { ContactoInterface, IRequestContacto } from '@app/core/interfaces/contacto-interface';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { IMantenimiento, IRequestPostMantenimiento } from '@app/core/interfaces/IMantenimientos';
import { LISTADO_MANTENIMIENTOS } from 'src/assets/dataDemo/opcionesTipoMantenimiento-demo';
import { LineasInfraestructuraService } from '../lineasInfraestructura/lineas-infraestructura.service';
import { ILineaInfraestructura, LineaInfraestructuraPropuesta, RequestPostLineaInfraestructura } from '@app/core/interfaces/linea-infraestructura';
import { ProyectoItemsService } from './proyecto-items.service';
import { EstadosProyectoItem, ProyectoItemsInterface } from '@app/core/interfaces/proyecto-items-interface';
import { ComentarioInterface } from '@app/core/interfaces/comentario-interface';
import { FICHEROS_PROYECTO } from 'src/assets/dataDemo/proyectosDatos-demo';
import { ISeccionesDocumentos } from '@app/core/interfaces/ISeccionesDocumentos';
import { Comentario } from '@app/neo/neoCore/entities/Comentario/Comentario';
import { IRespApi } from '@app/neo/neoShared/helpers/interfaces/IResp-api';
import { LOADER_TRANSPARENT } from '@app/neo/neoCore/interceptors/loaderInterceptor/loader.interceptor';
import { format } from 'date-fns';


@Injectable({
  providedIn: 'root'
})
export class ProyectosService {
  contextLoaderTransparent = { context: new HttpContext().set(LOADER_TRANSPARENT, true) };
  public editandoProyecto$ = new BehaviorSubject<boolean>(false);
  public editandoResponsableProyecto$ = new BehaviorSubject<boolean>(false);
  public editandoContactoResponsableProyecto$ = new BehaviorSubject<boolean>(false);
  public editando$ = new BehaviorSubject<boolean>(false);
  public contactoResponsableProyecto$: BehaviorSubject<ContactoInterface> = new BehaviorSubject<ContactoInterface>(null);
  nombreEntidad = 'proyecto';
  urlProyectos       = environment.api_base_url + '/proyectos';
  urlProyectoTipos   = environment.api_base_url + '/proyectoTipos';
  urlProyectoTiposServicios= environment.api_base_url + '/proyectoServicios';
  urlTextos               = environment.api_base_url + '/textos';
  // Emit valor sólo con next, sin devolver el último valor con behaviourSubject al subs
  public error422Api$: Subject<RespApi> = new Subject<RespApi>();

  public proyecto$: BehaviorSubject<ProyectoInterface> = new BehaviorSubject<ProyectoInterface>(null);
  public proyectos$: BehaviorSubject<ProyectoInterface[]> = new BehaviorSubject<ProyectoInterface[]>(null);
  public totalProyectos$: BehaviorSubject<number> = new BehaviorSubject<number>(null);


  public mantenimientos$: BehaviorSubject<IMantenimiento> = new BehaviorSubject<IMantenimiento>(null);
  public totalMantenimientos$: BehaviorSubject<number> = new BehaviorSubject<number>(null);

  public comentarios$: BehaviorSubject<Comentario[]> = new BehaviorSubject<Comentario[]>([]);


  constructor(
    private http: HttpClient,
    private auxiliar: AuxiliarService,
    private empleadosService: EmpleadosService,
    // DUDA si resusamos endpoint o necesarios nuevos
    private lineasInfraestructuraService: LineasInfraestructuraService,
    private proyectoItemsService: ProyectoItemsService,

  ) { }

  set editando(flag: boolean) {
    this.editando$.next(flag);
  }


  set editandoProyecto(flag: boolean) {
    this.editandoProyecto$.next(flag);
  }

  set editandoResponsableProyecto(flag: boolean) {
    this.editandoResponsableProyecto$.next(flag);
  }

  set editandoContactoResponsableProyecto(flag: boolean) {
    this.editandoContactoResponsableProyecto$.next(flag);
  }
  
  set contactoResponsableProyecto(contactoResponsableProyecto: ContactoInterface) {
    this.contactoResponsableProyecto$.next(contactoResponsableProyecto);
  }

  set proyecto(proyecto: ProyectoInterface) {
    this.proyecto$.next(proyecto);
  }
  
  set comentarios( comentarios: Comentario[] ) {
    this.comentarios$.next(comentarios);
  }


  getAll(paginatorType?: TipoPaginadorEnum, paginator?: Paginator, filtros?: any, loaderTransparente?: boolean): Observable<ProyectoInterface[]> {
    let paramContext = (loaderTransparente) ? { ...this.contextLoaderTransparent } : {};
    if (false) {
      return this.http.get(`${this.urlProyectos}?${ this.auxiliar.extraerFiltros(filtros) }`, {}).pipe(
        map((data: ProyectoInterface[]) => data['data']));
    } else {
      
      return this.http.get(`${this.urlProyectos}?${this.auxiliar.extraerFiltrosPaginacion(paginator)}${this.auxiliar.extraerFiltros(filtros)}`, paramContext).pipe(
        tap( (data: RespApi )=> {this.totalProyectos$.next( data.total );}),
        tap( (data: RespApi )=> {this.proyectos$.next( data.data );}),
        map((data: RespApi) => this.mapearProyectos(data['data']) ));
    }
  }

  get(id): Observable<ProyectoInterface>{
    return this.http.get(`${this.urlProyectos}/${id}`).pipe(
      map((data: RespApi) => {
        let proyecto: ProyectoInterface = data['data'];
        return proyecto;
      })
    );
  }

  mapearProyectos(proyectos: ProyectoInterface[]) {
    // if (proyectos.length) {
    // }
    return proyectos;
  }

  mapearProyecto(proyecto: ProyectoInterface) {
    return proyecto;
  }

    // contenido options de los select entidades
  mapearListadosEntidadesRelacionadas(): Observable<any> {
      const responseEmpleados                 = this.empleadosService.getAll();
      const responseProyectoTipo              = this.getProyectoTipos();      
      const responseEmpleadosJefeProyecto     = this.empleadosService.getAllJefeProyecto(null, null, {orden: 'nombre', tipoOrden: 'asc'});
      return forkJoin([
        responseEmpleados, 
        responseProyectoTipo,
        responseEmpleadosJefeProyecto
      ])
    }
  
 

  

  create(request: IRequestPostProyecto): Observable<any> {
    return this.http.post<RespApi>( `${this.urlProyectos}`, request ) .pipe(
      map( (resp: RespApi) => {
        return resp.data;       
      }),
      catchError( (err: RespApi) => {       
        return this.handleError( err,  'IRequestPostProyecto');
      })
    );  
  }

  update(id: any, request?: IRequestPatchProyecto): Observable<any>{
    return this.http.patch( `${this.urlProyectos}/${id}`, request ).pipe(
      map((data: IRequestPatchProyecto[]) => data['data']),
      catchError( (err: RespApi) => {       
        return this.handleError( err);
      })
    );
  }

  // entrada personalizada a endpoint patch cuenta para edicion responsables 
  // uso correcto en cuetnas prospecto
  updateResponsable(id: string, request: RequestPatchJefeProyecto) {
    return this.http.patch( `${this.urlProyectos}/${id}`, request ).pipe(
      map((data: RespApi) => data['data']),
      catchError( (err: RespApi) => {       
        return this.handleError( err,  'RequestPatchJefeProyecto');
      })
    );
  }

  /************************************ */
  /** CONTACTO RESPONSABLE PROYECTO */
  /************************************ */
  crearContacto(id: string, request: IRequestContacto) {
    // return new Observable<any>( observer => {
    //   observer.next(true);
    //   observer.complete();
    // });    
    return this.http.post(`${this.urlProyectos}/${id}/contactoResponsableProyecto`, request).pipe(
      map((data: RespApi[]) => data['data']),
      catchError( (err: RespApi) => {       
        return this.handleError( err,  'IRequestContacto');
      })
    );
  }

  /****************************/
  /* DOCUMENTOS                */
  /*****************************/
  getFicheros(id: string, clave?) {
    console.log('[Ficheros llamada]');
    let filtroClave = (clave) ? `?clave=${clave}` : '';
    return this.http.get(`${this.urlProyectos}/${id}/ficheros${filtroClave}`).pipe(
      map((data: RespApi) => data['data']));
  }

  getFichero(id: string, idFichero: string) {
    console.log('[Ficheros llamada]');
    return this.http.get(`${this.urlProyectos}/${id}/ficheros/${idFichero}`).pipe(
      map((data: RespApi) => data['data']));
  }

  subirFicheros(idEntidad: string, request: any) {
    return this.http.post<IRespApi>(`${this.urlProyectos}/${idEntidad}/ficheros`, request).pipe(
      map((resp: IRespApi) => resp.data),
      catchError((err: IRespApi) => {
        return this.handleError(err, 'IRequestPost' + this.nombreEntidad + 'Fichero');
      })
    );
  }
  editarFichero(idFichero: string, request: any) {
    return this.http.patch<IRespApi>(`${this.urlProyectos}/${idFichero}/ficheros`, request).pipe(
      map((resp: IRespApi) => resp.data),
      catchError((err: IRespApi) => {
        return this.handleError(err, 'IRequestEditar' + this.nombreEntidad + 'Fichero');
      })
    );
  }
  eliminarFichero(idFichero: string) {
    return this.http.delete(`${this.urlProyectos}/${idFichero}/ficheros`).pipe(
      map((valor: string) => this.auxiliar.getBoolean(valor)),
      catchError((err: IRespApi) => {
        return this.handleError(err, 'IRequestDelete' + this.nombreEntidad + 'Fichero');
      })
    );
  }

  configuracionFicheros(clave?: string, parametro?: string): Observable<any> {
    let paramClave = (clave) ? `?clave=${clave}` : '';
    paramClave = (clave && parametro) ? `${paramClave}&parametro=${parametro}` : paramClave;
    return this.http.get(`${this.urlProyectos}/configuracionFicheros${paramClave}`).pipe(
      map((data: RespApi) => data['data']));
  }


 
  /********************************/
  /* COMENTARIOS                    */
  /********************************/
  getComentarios(proyecto): Observable<ComentarioInterface[]> {
    let filtros = { orden: 'id', tipoOrden: 'asc' };
    return this.http.get(`${this.urlProyectos}/${proyecto.id}/comentarios?${this.auxiliar.extraerFiltros(filtros)}`).pipe(
      // tap( data => console.log('info comentarios ', data)),
      map((data: RespApi) => this.mapearComentario(data.data, proyecto.id))
    );
 
  }
  // TODO: Revisar mapeo entre interfaces
  // TODO: Obtener autor de servicio
  mapearComentario(comentarios: ComentarioInterface[], idObjeto: string): ComentarioInterface[] {
    comentarios.map(object => Object.assign(object, {
      idObjeto
    }));
    return comentarios;
  }

  createComentario(comentario: ComentarioInterface): Observable<any> {

    if( comentario ) {
      const objComentario = Object.assign({texto: comentario.contenido});
      return this.http.post(`${this.urlProyectos}/${comentario.idObjeto}/comentarios`, objComentario).pipe(
        map( (data:RespApi) => data),
        catchError( (err: RespApi) => {       
          return throwError({'error' : true, 'data': err.data });
        })
      );     
    } else {
      return throwError(new Error('Error'));
    }
    
  }

  // TODO llevar a servicio TextosServicio
  updateComentario(comentario: ComentarioInterface): Observable<any> {
    const objComentario = Object.assign({texto: comentario.contenido});
    return this.http.patch( `${this.urlTextos}/${comentario.id}`, objComentario ).pipe(
      map((data: ComentarioInterface[]) => data['data']),
      catchError( (err: RespApi) => {       
        if ( err.codigoError === 422 ) {
          this.error422Api$.next(err);
        } 
        return throwError({'error' : true, 'data': err.data });
      })
    );
  }

  // TODO llevar a servicio TextosServicio
  deleteComentario(comentario: ComentarioInterface): Observable<any> {
    if (comentario) {
      return this.http.delete(`${this.urlTextos}/${comentario.id}`);
    } else {
      return throwError(new Error('Error'));
    }
  }
  
  /************************************* */
  /** SERVICIOS */
  /************************************* */
  // getServicios(id, paginatorType?: TipoPaginadorEnum, paginator?: Paginator, filtros?: any): Observable<ProyectoItemsInterface[]> {
  //   return this.proyectoItemsService.getAll(paginatorType, paginator, {...filtros, idProyecto: id});
  // }

  getServicios(id, paginatorType?: TipoPaginadorEnum, paginator?: Paginator, filtros?: any, borradorOportunidad?: boolean): Observable<ProyectoItemsInterface[]> {
    // NO FILTRAMOS ESTADO BORRADOR OPORTUNIDAD
    let filtrarBorradorOportunidad = (borradorOportunidad !== undefined) ? borradorOportunidad : true;
    return this.http.get(`${this.urlProyectos}/${id}/proyectoItems?${this.auxiliar.extraerFiltrosPaginacion(paginator)}${this.auxiliar.extraerFiltros(filtros)}`, {}).pipe(
      map((data: RespApi) => data['data']),
      map((data: any[]) => data.filter(servicio => (filtrarBorradorOportunidad) ? servicio['proyectoItemEstado'].id != EstadosProyectoItem.BorradorOportunidad : true)),
      // filter((data: any) => (true) ? data['proyectoItemEstado'].id != EstadosProyectoItem.BorradorOportunidad : true),
      map((data: any[]) => data.map(item => item = { ...item, esGitlab: this.auxiliar.getBoolean(item.esGitlab), fechaEstadoPlanificado: (item.fechaEstadoPlanificado != null) ? `${new Date(item.fechaEstadoPlanificado).getDate()}-${new Date(item.fechaEstadoPlanificado).getMonth() + 1}-${new Date(item.fechaEstadoPlanificado).getFullYear()}` : '' })),
      tap((data: any[]) => console.log)
    );
  }




  getServiciosTotal(id, paginatorType?: TipoPaginadorEnum, paginator?: Paginator, filtros?: any, borradorOportunidad?: boolean): Observable<ProyectoItemsInterface[]> {
    // NO FILTRAMOS ESTADO BORRADOR OPORTUNIDAD
    let filtrarBorradorOportunidad = (borradorOportunidad !== undefined) ? borradorOportunidad : true;
    return this.http.get(`${this.urlProyectos}/${id}/proyectoItems?${this.auxiliar.extraerFiltrosPaginacion(paginator)}${this.auxiliar.extraerFiltros(filtros)}`, {}).pipe(
      map((data: RespApi) => this.mapearServicios(data, filtrarBorradorOportunidad)),
      // map((data: any[]) => data.filter(servicio => (filtrarBorradorOportunidad) ? servicio['proyectoItemEstado'].id != EstadosProyectoItem.BorradorOportunidad : true)),
      // // filter((data: any) => (true) ? data['proyectoItemEstado'].id != EstadosProyectoItem.BorradorOportunidad : true),
      // map((data: any[]) => data.map(item => item = { ...item, fechaEstadoPlanificado: (item.fechaEstadoPlanificado != null) ? `${new Date(item.fechaEstadoPlanificado).getDate()}-${new Date(item.fechaEstadoPlanificado).getMonth() + 1}-${new Date(item.fechaEstadoPlanificado).getFullYear()}` : '' })),
      tap((data: any[]) => console.log)
    );
  }

  mapearServicios(response, filtrarBorradorOportunidad: boolean) {
    let servicios = response.data;
    servicios = servicios.filter(servicio => (filtrarBorradorOportunidad) ? servicio['proyectoItemEstado'].id != EstadosProyectoItem.BorradorOportunidad : true);
    servicios = servicios.map(item => item = {
      ...item,
      esGitlab: this.auxiliar.getBoolean(item.esGitlab),
      fechaEstadoPlanificado: (item.fechaEstadoPlanificado != null) ? `${new Date(item.fechaEstadoPlanificado).getDate()}-${new Date(item.fechaEstadoPlanificado).getMonth() + 1}-${new Date(item.fechaEstadoPlanificado).getFullYear()}` : ''
    })
    return { ...response, data: servicios };
  }

  /************************************* */
  /** LINEAS INFRAESTRUCTURA */
  /************************************* */
  getLineasInfraestructura(id, paginatorType?: TipoPaginadorEnum, paginator?: Paginator, filtros?: any): Observable<any> {
    return this.http.get(`${this.urlProyectos}/${id}/lineaInfraestructuras?${this.auxiliar.extraerFiltrosPaginacion(paginator)}${this.auxiliar.extraerFiltros(filtros)}`)
      .pipe(
        map((data: RespApi) => {
          return { lineas: this.mapearLineasInfraestructura(data.data), total: data.total }
        }
        ),
        catchError((err: RespApi) => {
          return this.handleError(err, 'getLineasInfraestructura');
        })
      );
  }

  private mapearLineasInfraestructura(lineas: LineaInfraestructuraPropuesta[]) {
    if (lineas.length) {
      lineas.forEach((element, index) => {
        lineas[index] = this.mapearLineaInfraestructuraPropuesta(element);
      });
    }
    return lineas;
  }

  private mapearLineaInfraestructuraPropuesta(linea: LineaInfraestructuraPropuesta): LineaInfraestructuraPropuesta {
    linea.importe = +linea.importe;
    linea.unidades = +linea.unidades;
    return linea;
  }

  createLineaInfraestructura(id: string, request: any) {
    return this.http.post( `${this.urlProyectos}/${id}/lineaInfraestructuras`, request ).pipe(
      map((data: RespApi) => data['data']),
      catchError( (err: RespApi) => {       
        return this.handleError(err, 'RequestPostLineaInfraestructuraPropuesta');
      })
    );
  }

  programarHitosFacturacionPuntualFecha(id: string, request: any) {
    return this.http.post(`${this.urlProyectos}/${id}/programarHitosFacturacionPuntualFecha`, request).pipe(
      map((data: RespApi) => data['data']),
      catchError((err: RespApi) => {
        return this.handleError(err, 'RequestPostPogramarHitosFacturacionPeriodicos');
      })
    );
  }

  programarHitosFacturacionPuntualNoCobrable(id: string, request: any) {
    return this.http.post(`${this.urlProyectos}/${id}/programarHitosFacturacionPuntualNoCobrable`, request).pipe(
      map((data: RespApi) => data['data']),
      catchError((err: RespApi) => {
        return this.handleError(err, 'RequestPostProgramarHitosFacturacionPuntualNoCobrable');
      })
    );
  }

  programarHitosFacturacionPuntualManual(id: string, request: any) {
    return this.http.post(`${this.urlProyectos}/${id}/programarHitosFacturacionPuntualManual`, request).pipe(
      map((data: RespApi) => data['data']),
      catchError((err: RespApi) => {
        return this.handleError(err, 'RequestPostProgramarHitosFacturacionPuntualManual');
      })
    );
  }


  programarHitosFacturacionPeriodicos(id: string, request: any) {
    return this.http.post(`${this.urlProyectos}/${id}/programarHitosFacturacionPeriodicos`, request).pipe(
      map((data: RespApi) => data['data']),
      catchError((err: RespApi) => {
        return this.handleError(err, 'RequestPostPogramarHitosFacturacionPeriodicos');
      })
    );
  }


  finalizarHitosFacturacionPeriodicos(id: string, request: any) {
    return this.http.post(`${this.urlProyectos}/${id}/finalizarHitosFacturacionPeriodicos`, request).pipe(
      map((data: RespApi) => data['data']),
      catchError((err: RespApi) => {
        return this.handleError(err, 'RequestPostFinalizarHitosFacturacionPeriodicos');
      })
    );
  }




  /************************************* */
  /** MANTENIMIENTO */
  /************************************* */
  getMantenimientos(id, paginatorType?: TipoPaginadorEnum, paginator?: Paginator, filtros?: any): Observable<IMantenimiento[]> {
    // eliminamos aquellos con estado borrador oportunidad

    let request = `${this.urlProyectos}/${id}/mantenimientos?${this.auxiliar.extraerFiltrosPaginacion(paginator)}${this.auxiliar.extraerFiltros(filtros)}`;
    return this.http.get(request, {}).pipe(
      tap((data: RespApi) => { this.totalMantenimientos$.next(data.total); }),
      map((data: RespApi) => data['data']));
  }

  createMantenimiento(id: string, request: IRequestPostMantenimiento) {
    return this.http.post( `${this.urlProyectos}/${id}/mantenimiento`, request ).pipe(
      map((data: RespApi) => data['data']),
      catchError( (err: RespApi) => {       
        return this.handleError( err,  'IRequestPostMantenimiento');
      })
    );
  }


  /************************************* */
  /** PROYECTOS TIPO */
  /************************************* */
 
  getProyectoTipos(): Observable<ProyectoTipoInterface[]> {
    return this.http.get(this.urlProyectoTipos, {}).pipe(
      // tap(data => console.log('Data: ', data)),
      map((data: ProyectoTipoInterface[]) => data['data']));
  }

   
  getProyectoTipo(id: string): Observable<ProyectoTipoInterface> {
    return this.http.get(`${this.urlProyectoTipos}/${id}`).pipe(
      // tap(data => console.log('Data: ', data)),
      map((data: RespApi) => data['data']));
  }
  

  getProyectoTipoServicios(): Observable<ProyectoTipoServicioInterface[]> {
    return this.http.get(this.urlProyectoTiposServicios, {}).pipe(
      // tap(data => console.log('Data: ', data)),
      map((data: ProyectoTipoServicioInterface[]) => data['data']));
  }

  

  /*********************************************** */
  /** CONCEPTOS DEFECTO ASOCIADOS A PROYECTOS TIPO */
  /*********************************************** */

  getConceptosDefecto(id: string): Observable<IConceptoDefecto> {
    return this.http.get(`${this.urlProyectoTipos}/${id}/conceptosDefecto`).pipe(
      // tap(data => console.log('Data: ', data)),
      map((data: RespApi) => data['data']));
  }

  createConceptosDefecto(id: string, request: RequestPostConceptosDesfecto): Observable<any>{
    return this.http.post<RespApi>( `${this.urlProyectoTipos}/${id}/conceptosDefecto`, request ) .pipe(
      map( (resp: RespApi) => resp.data),
      catchError( (err: RespApi) => {       
        return this.handleError( err,  'RequestPostConceptosDesfecto');
      })
    );
  }

    /*********************************************** */
  /** HITOS FACTURACION DEFECTO ASOCIADOS A PROYECTOS TIPO */
  /*********************************************** */

  getHitosFacturacionDefecto(id: string): Observable<IHitosFacturacionDefecto> {
    return this.http.get(`${this.urlProyectoTipos}/${id}/hitosFacturacionDefecto`).pipe(
      // tap(data => console.log('Data: ', data)),
      map((data: RespApi) => data['data']));
  }

  createHitosFacturacionDefecto(id: string, request: RequestPostHitosFacturacionDefecto): Observable<any>{
    return this.http.post<RespApi>( `${this.urlProyectoTipos}/${id}/hitosFacturacionDefecto`, request ) .pipe(
      map( (resp: RespApi) => resp.data),
      catchError( (err: RespApi) => {       
        return this.handleError( err,  'RequestPostHitosFacturacionDefecto');
      })
    );
  }

  facturar(request) {
    return this.http.post<IRespApi>(`${this.urlProyectos}/facturar`, request).pipe(
      map((resp: IRespApi) => {
        return resp.data;
      }),
      catchError((err: IRespApi) => {
        return this.handleError(err, 'IRequestPostFacturar');
      })
    );
  }
    /************************************ 
   * Funciones apoyo                  *
  *************************************/
    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<ProyectoInterface> {
      const id = route.params.codigo;
      return this.get(id);
    }
  
  /********************************/
  /* MANEJADOR ERRORES            */
  /********************************/
  private handleError(err: RespApi | any, idRequest = '') {
    // control error server con un html ok
    if (err == 'OK') {
      let mensaje = environment.errorServidorSinCodigo;
      return throwError({ 'error': true, 'data': mensaje, mensaje, 'err': err });
    }
    if (err == 'Unknown Error') {
      let mensaje = environment.errorServidorUnknown;
      return throwError({ 'error': true, 'data': mensaje, mensaje, 'err': err });
    }
     // dialog específico
     err.request = idRequest;
     if ( err.codigoError === 422) {
       this.error422Api$.next(err);
     } 
 
     // pantalla común
     let mensaje = err?.mensaje;
     if ( err.codigoError === 403) {
       mensaje = `${ err.mensaje }: `;
       err.data.forEach(element => {
         mensaje += element.mensaje;
       });
     }
     if (err.codigoError === 404  || err.codigoError === 422) {
       let avisos = '';
       if ( err.data ) {
         err.data.forEach(element => {
           if ( element.id === 999 ) {
             avisos = ' ' + element.mensaje + ' ';
           }
         });
       }
       mensaje = (avisos.length)  ? avisos : err?.mensaje;
     }
 
     if (err.codigoError === 500) {
       let avisos = '';
       if ( err.data ) {
         err.data.forEach(element => {
           if ( element.id === 999 ) {
             avisos = ' ' + element.mensaje + ' ';
           }
         });
       }
       mensaje = err?.mensaje +  avisos;
     }
     console.log(` Error Operacion ${err.data} ${mensaje} ${err}`);
     return throwError({'error' : true, 'data': err.data, mensaje, 'err': err });
  }

}
